import { persistReducer } from 'redux-persist'
import { Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  GetSystemBackupTableData: '[GetSystemBackupTableData] Action',
  SetSystemBackupData: '[SetSystemBackupData] Action',
  GetSystemBackupTranslateData: '[GetSystemBackupTranslateData] Action',
}

const initialSystemBackupState: ISystemBackupState = {
  systemBackupColumnList: [],
  systemBackupColumnValues: [],
  systemBackupDefinitions: [],
  systemBackupColumnNames: [],
  systemBackupDataTypes: [],
  systemBackupDe: [],
  systemBackupEn: [],

  systemBackupsOptions: []
}

export interface ISystemBackupState {
  systemBackupColumnValues: [],
  systemBackupColumnList: [],
  systemBackupDefinitions: []
  systemBackupColumnNames: [],
  systemBackupDataTypes: [],
  systemBackupDe: [],
  systemBackupEn: [],

  systemBackupsOptions: []
}

export const reducer = persistReducer(
  { storage, key: 'portal-SystemBackup', whitelist:  [ ] },
  (state: ISystemBackupState = initialSystemBackupState, action: any) => {
    switch (action.type) {
      case actionTypes.GetSystemBackupTableData: {
        const systemBackupColumnValues = action.payload.data.backupLogs;
        let headers = JSON.parse(action.payload.data.headers);
        let systemBackupDefinitions = JSON.parse(action.payload.data.definitions);
        let systemBackupColumnList: any = [];
       
        headers.forEach((element: any) => {
          let newElement: any = [...Object.values(element)]
          systemBackupColumnList.push(newElement[0]);
        });
        return { ...state, systemBackupColumnList, systemBackupColumnValues, systemBackupDefinitions};
      }
    
      case actionTypes.SetSystemBackupData: {
        const systemBackupColumnValues = action.payload.data;
        return { ...state, systemBackupColumnValues };
      }

      case actionTypes.GetSystemBackupTranslateData: {
        const systemBackupDe = JSON.parse(action.payload.data.de);
        const systemBackupEn = JSON.parse(action.payload.data.en);
        return { ...state, systemBackupDe, systemBackupEn };
      }
      
      default:
        return state
    }
  }
)

export const actions = {
  getSystemBackupTableData: (data: any) => ({ type: actionTypes.GetSystemBackupTableData, payload: { data } }),
  getTranslateData: (data: any) => ({ type: actionTypes.GetSystemBackupTranslateData, payload: { data } }),
  setSystemBackupData: (data: any) => ({ type: actionTypes.SetSystemBackupData, payload: { data } }),
  store: () => ({ type: "def" }),
}

export function* saga() {

}
